var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mgl-map-wrapper"},[_vm._m(0),(_vm.initialized)?_vm._t("default"):_vm._e()],2)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{ref:"container",attrs:{"id":_vm.container}})
}]

export { render, staticRenderFns }